import { SEVERITY_RANK, worstSeverity } from "../components/ClauseFindings";

/**
 * Pure helpers for the pre-signature hub page (list + launcher eligibility).
 * No React, no routing, no external dependencies — kept importable from unit
 * tests without pulling in react-router-dom (see PreSignature.jsx, which
 * imports and re-exports these).
 */
export const ELIGIBLE_TYPES = ["contract", "financing", "insurance", "lease"];

/**
 * Enumeration lisible des types couverts, construite depuis ELIGIBLE_TYPES.
 * Les messages qui listaient les types en dur derivaient sinon a chaque ajout
 * d'un nouveau type (cf. la liste restee a 3 elements dans 4 chaines i18n).
 * `t` est passe par l'appelant pour garder ce module sans dependance i18n.
 */
export function eligibleTypesLabel(t) {
  const labels = ELIGIBLE_TYPES.map((type) => t(`types.${type}`));
  if (labels.length < 2) return labels[0] || "";
  return `${labels.slice(0, -1).join(", ")} ${t("types.conjunction")} ${labels[labels.length - 1]}`;
}

export function isEligibleDocument(doc) {
  if (!doc || typeof doc !== "object") return false;
  return doc.status === "completed" && ELIGIBLE_TYPES.includes(doc.document_type);
}

export function buildRows(decisions, docsById) {
  return (Array.isArray(decisions) ? decisions : []).map((d) => {
    const docId = (d.subject_doc_ids || [])[0] || "";
    const clauses = d.clause_findings || [];
    return {
      id: d.id,
      filename: docsById?.[docId]?.filename || docId,
      verdict: d.verdict,
      clauseCount: clauses.length,
      worst: worstSeverity(clauses),
      createdAt: d.created_at,
    };
  });
}

export function filterRows(rows, { search, severity }) {
  const q = (search || "").trim().toLowerCase();
  const max = severity && severity !== "All" ? SEVERITY_RANK[severity] : null;
  return (rows || []).filter((r) => {
    if (q && !(r.filename || "").toLowerCase().includes(q)) return false;
    if (max !== null) {
      if (!r.worst) return false;
      if ((SEVERITY_RANK[r.worst] ?? 9) > max) return false;
    }
    return true;
  });
}

export function unavailableMessageKey(detail) {
  if (!detail || typeof detail !== "object") return null;
  if (detail.code !== "pre_signature_unavailable") return null;
  if (!["needs_review", "no_enrichment"].includes(detail.reason)) return null;
  return `unavailable.${detail.reason}`;
}
